import React, {useEffect, useState} from "react";
import PageHeaderLayout from "../../../../layout/pageHeaderLayout";
import {
    Button,
    Card,
    Cascader,
    Col,
    Divider,
    Form,
    Input,
    InputNumber,
    message,
    Row,
    Select,
    Space,
} from "antd";
import {EditOutlined, RollbackOutlined, ImportOutlined, StopOutlined} from "@ant-design/icons";
import {useRequest} from "ahooks";
import * as api from "../../../../apis/platforms/admin/expressFreight";
import {useParams} from "react-router";
import {useHistory} from "react-router-dom";
import {getAreaCascade as getAreaCascadeApi} from "../../../../apis/common";
import {useForm} from "antd/lib/form/Form";
import {getCategoriesDict} from "../../../../apis/productCategory";
import AreaSelect from "../../../../components/AreaSelect";
import UploadModal from "../../../../components/UploadModal";

export default function ExpressFreightEdit() {

    const history = useHistory()
    const {id} = useParams<any>()
    const [form] = useForm()
    const [canEdit, setCanEdit] = useState(false)
    const [expressFreightDetail, setExpressFreightDetail] = useState<any>({})
    const [area, setArea] = useState<any>()
    const [areaUse, setAreaUse] = useState<any>()
    const [categories, setCategories] = useState<any>()
    const [uploadModalVisible, setUploadModalVisible] = useState(false)

    useEffect(() => {
        getAreaCascade(1, 2).then((areaRes) => {
            if (id)
                init(areaRes)
        })
    }, [id])

    function init(area: any) {
        getExpressFreightDetail(id).then((res) => {
            if (res.data.data.rule === 'weight') {
                form.setFieldValue('weightForm', res.data.data.weightItem.map((item: any) => {
                    return {
                        ...item,
                        area: item.area.split(',').map(Number)
                    }
                }))
                let tmp = doDisableArea(area.data.data, res.data.data.weightItem.map((item: any) => {
                    return item.areaLast
                }))
                setAreaUse(tmp)
            } else if (res.data.data.rule === 'box') {
                getCategories()
                form.setFieldValue('boxForm', res.data.data.boxItem.map((item: any) => {
                    return {
                        ...item,
                        area: item.area.split(',').map(Number)
                    }
                }))
            }

        })
    }

    const {runAsync: getExpressFreightDetail} = useRequest(api.getExpressFreightDetail, {
        manual: true,
        onSuccess: (res) => {
            setExpressFreightDetail(res.data.data)
        }
    })

    const {runAsync: getAreaCascade} = useRequest(getAreaCascadeApi, {
        manual: true,
        onSuccess: (res) => {
            setArea(res.data.data)
            setAreaUse(res.data.data)
        }
    })

    const {run: getCategories} = useRequest(getCategoriesDict, {
        manual: true,
        onSuccess: (res) => {
            setCategories(res.data.data.map((item: any) => {
                return {
                    label: item.name,
                    value: item.id
                }
            }))
        }
    })

    const {run: addWeightItem, loading: addWeightItemLoading} = useRequest(api.addWeightItem, {
        manual: true,
        onSuccess: (res) => {
            message.success("保存成功")
            init(area)
            setCanEdit(false)
        }
    })

    const {run: addBoxItem, loading: addBoxItemLoading} = useRequest(api.addBoxItem, {
        manual: true,
        onSuccess: (res) => {
            message.success("保存成功")
            init(area)
            setCanEdit(false)
        }
    })

    const {
        run: doImportExpressFreight,
        loading: doImportExpressFreightLoading
    } = useRequest(expressFreightDetail.rule === 'weight' ? api.importExpressFreightWeight : api.importExpressFreightBox, {
        manual: true,
        onSuccess: () => {
            setUploadModalVisible(false)
            init(area)
            message.success("导入成功")
        }
    })

    function doSubmit() {
        form.validateFields().then(values => {
            if (values.weightForm) {
                const sendData = values.weightForm.map((item: any) => {
                    return {
                        ...item,
                        areaLast: item.area[item.area.length - 1],
                        area: item.area.toString(),
                    }
                })
                addWeightItem(id, sendData)
            } else if (values.boxForm) {
                const sendData = values.boxForm.map((item: any) => {
                    return {
                        ...item,
                        areaLast: item.area[item.area.length - 1],
                        area: item.area.toString(),
                    }
                })
                addBoxItem(id, sendData)
            }
        })
    }

    function disableArea(value: any, selectedOptions: any) {
        if (selectedOptions[selectedOptions.length - 1].areaIndex === null)
            return
        else {
            let disableAreaCode: any = []
            form.getFieldsValue().weightForm.map((item: any) => {
                if (item.area)
                    disableAreaCode.push(item.area[item.area.length - 1])
            })
            const tmp = doDisableArea(area, disableAreaCode)
            setAreaUse(tmp)
        }
    }

    function doDisableArea(areaList: any, disableAreaCode: any) {
        if (areaList) {
            return areaList.reduce((temp: any, item: any) => {
                let children = []
                if (item.children) {
                    children = doDisableArea(item.children, disableAreaCode)
                }
                if (disableAreaCode.includes(item.areaCode)) {
                    let newItem = {
                        ...item,
                        disabled: true
                    }
                    temp.push({...newItem, children})
                } else {
                    temp.push({...item, children})
                }
                return temp
            }, [])
        }
    }

    async function validatorAreaProductCategoryRepeat(rule: any, value: any) {
        let path = rule.fullField.split(".")
        path[path.length - 1] = "area"
        let area = form.getFieldValue(path)
        let allLine = form.getFieldValue("boxForm")
        let flag = allLine.filter((item: any) => {
            return area[area.length - 1] === item.area[item.area.length - 1] && item.productCategoryId === value
        }).length > 1
        if (flag) {
            return Promise.reject('存在相同地区相同类型')
        } else {
            return Promise.resolve()
        }
    }


    return (
        <PageHeaderLayout withFooterBar={canEdit}
                          onOk={doSubmit}
                          onCancel={() => setCanEdit(false)}
                          btnLoading={addWeightItemLoading && addBoxItemLoading}>
            <Card title={expressFreightDetail.express} extra={
                <Space split={<Divider type="vertical"/>} style={{fontWeight: "bold"}}>
                    <a onClick={() => setUploadModalVisible(true)}><ImportOutlined/> 导入</a>
                    {id &&
                        <>
                            <a onClick={() => setCanEdit(true)}><EditOutlined/> 修改</a>
                        </>
                    }
                    <a onClick={() => history.goBack()}><StopOutlined/> 停用</a>
                    <a onClick={() => history.goBack()}><RollbackOutlined/> 返回</a>
                </Space>
            }>
                {expressFreightDetail.rule === 'weight' ?
                    <Form form={form} disabled={!canEdit}>
                        <Row gutter={10} style={{marginBottom: 10}}>
                            <Col span={2}/>
                            <Col span={4} style={{color: "red"}}>* 地区</Col>
                            <Col span={4} style={{color: "red"}}>* 首重Kg</Col>
                            <Col span={4} style={{color: "red"}}>* 首重价格(元)</Col>
                            <Col span={4} style={{color: "red"}}>* 续重Kg</Col>
                            <Col span={4} style={{color: "red"}}>* 续重价格(元)</Col>
                            <Col span={2}/>
                        </Row>
                        <Form.List name={'weightForm'} initialValue={[{}]}>
                            {(fields, {add, remove}) => (
                                <>
                                    {
                                        fields.map(field => (
                                            <Row gutter={10}>
                                                <Form.Item name={[field.name, 'id']}/>
                                                <Col key={field.key} span={2}>
                                                    {canEdit && <Space>
                                                        <Space>
                                                            <Button onClick={() => add()}>+</Button>
                                                            <Button onClick={() => remove(field.name)}>-</Button>
                                                        </Space>
                                                    </Space>}
                                                </Col>
                                                <Col span={4}>
                                                    <Form.Item name={[field.name, 'area']}
                                                               rules={[{required: true, message: '请选择地区'}]}>
                                                        <Cascader
                                                            options={areaUse}
                                                            fieldNames={{label: 'areaName', value: 'areaCode'}}
                                                            onChange={(value, selectedOptions) => disableArea(value, selectedOptions)}
                                                            changeOnSelect
                                                        />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={4}>
                                                    <Form.Item name={[field.name, 'firstWeight']}
                                                               rules={[{required: true, message: '请输入首重'}]}>
                                                        <InputNumber style={{width: '100%'}}/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={4}>
                                                    <Form.Item name={[field.name, 'firstWeightPrice']}
                                                               rules={[{required: true, message: '请输入首重价格'}]}>
                                                        <InputNumber style={{width: '100%'}}/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={4}>
                                                    <Form.Item name={[field.name, 'continuationWeight']}
                                                               rules={[{required: true, message: '请输入续重'}]}>
                                                        <InputNumber style={{width: '100%'}}/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={4}>
                                                    <Form.Item name={[field.name, 'continuationWeightPrice']}
                                                               rules={[{required: true, message: '请输入续重价格'}]}>
                                                        <InputNumber style={{width: '100%'}}/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={2}/>
                                            </Row>
                                        ))
                                    }
                                    {fields.length > 0 ? null : <Button onClick={() => add()}>+</Button>}
                                </>
                            )}
                        </Form.List>
                    </Form>
                    :
                    <Form form={form} disabled={!canEdit}>
                        <Row gutter={10} style={{marginBottom: 10}}>
                            <Col span={2}/>
                            <Col span={5} style={{color: "red"}}>* 地区</Col>
                            <Col span={5} style={{color: "red"}}>* 产品线</Col>
                            <Col span={5} style={{color: "red"}}>* 箱基数</Col>
                            <Col span={5} style={{color: "red"}}>* 价格/箱(元)</Col>
                            <Col span={2}/>
                        </Row>
                        <Form.List name={'boxForm'} initialValue={[{}]}>
                            {(fields, {add, remove}) => (
                                <>
                                    {
                                        fields.map(field => (
                                            <Row gutter={10}>
                                                <Form.Item name={[field.name, 'id']}/>
                                                <Col key={field.key} span={2}>
                                                    {canEdit && <Space>
                                                        <Space>
                                                            <Button onClick={() => add()}>+</Button>
                                                            <Button onClick={() => remove(field.name)}>-</Button>
                                                        </Space>
                                                    </Space>}
                                                </Col>
                                                <Col span={5}>
                                                    <Form.Item name={[field.name, 'area']}
                                                               rules={[{required: true, message: '请选择地区'}]}>
                                                        <Cascader
                                                            options={areaUse}
                                                            fieldNames={{
                                                                label: 'areaName',
                                                                value: 'areaCode'
                                                            }}
                                                            changeOnSelect
                                                        />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={5}>
                                                    {/*<Form.Item*/}
                                                    {/*    dependencies={[['boxForm', field.name, 'area']]}*/}
                                                    {/*    noStyle>*/}
                                                    {/*    {({getFieldValue, getFieldsValue}) => {*/}
                                                    {/*        let newCategories = categories*/}
                                                    {/*        const allLine = getFieldsValue().boxForm*/}
                                                    {/*        const currentLineArea = getFieldValue(['boxForm', field.name, 'area'])*/}
                                                    {/*        if (allLine) {*/}
                                                    {/*            const disabledProductCategory: any = []*/}
                                                    {/*            allLine.forEach((item: any, index: number) => {*/}
                                                    {/*                if (item && item.area && item.productCategory && currentLineArea && field.name !== index) {*/}
                                                    {/*                    if (item.area[item.area.length - 1] === currentLineArea[currentLineArea.length - 1])*/}
                                                    {/*                        disabledProductCategory.push(item.productCategory)*/}
                                                    {/*                }*/}
                                                    {/*            })*/}
                                                    {/*            if (disabledProductCategory.length > 0) {*/}
                                                    {/*                newCategories = categories.map((item: any) => {*/}
                                                    {/*                    if (disabledProductCategory.includes(item.value)) {*/}
                                                    {/*                        return {*/}
                                                    {/*                            ...item,*/}
                                                    {/*                            disabled: true*/}
                                                    {/*                        }*/}
                                                    {/*                    } else {*/}
                                                    {/*                        return {...item}*/}
                                                    {/*                    }*/}
                                                    {/*                })*/}
                                                    {/*            }*/}
                                                    {/*            debugger*/}
                                                    {/*        }*/}
                                                    {/*        return (*/}
                                                    <Form.Item name={[field.name, 'productCategoryId']}
                                                               rules={[{
                                                                   required: true,
                                                                   message: '请选择产品线'
                                                               }, {validator: validatorAreaProductCategoryRepeat}]}>
                                                        <Select
                                                            // disabled={!currentLineArea}
                                                            style={{width: '100%'}}
                                                            options={categories}
                                                        />
                                                    </Form.Item>
                                                    {/*        )*/}
                                                    {/*    }}*/}
                                                    {/*</Form.Item>*/}

                                                </Col>
                                                <Col span={5}>
                                                    <Form.Item name={[field.name, 'boxBaseNum']}
                                                               rules={[{required: true, message: '请输入箱基数'}]}>
                                                        <InputNumber style={{width: '100%'}}/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={5}>
                                                    <Form.Item name={[field.name, 'boxBasePrice']}
                                                               rules={[{required: true, message: '请输入箱基数单价'}]}>
                                                        <InputNumber style={{width: '100%'}}/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={2}/>
                                            </Row>
                                        ))
                                    }
                                    {fields.length > 0 ? null : <Button onClick={() => add()}>+</Button>}
                                </>
                            )}
                        </Form.List>
                    </Form>
                }
            </Card>
            <UploadModal onUpload={file => doImportExpressFreight(id, file)}
                         open={uploadModalVisible}
                         title={'导入快递运费'}
                         template={expressFreightDetail.rule === 'weight' ? '/template/重量计费导入模板.xlsx' : '/template/按箱计费导入模板.xlsx'}
                         confirmLoading={doImportExpressFreightLoading}
                         onCancel={() => setUploadModalVisible(false)}/>
        </PageHeaderLayout>
    )
}